import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=c8357cf2&scoped=true&"
import script from "./Receipts.vue?vue&type=script&lang=js&"
export * from "./Receipts.vue?vue&type=script&lang=js&"
import style0 from "./Receipts.vue?vue&type=style&index=0&id=c8357cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8357cf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VLayout,VPagination,VProgressCircular,VSelect})
